module.exports = __webpack_public_path__ + "img/miyazaki.f8fed12a.png";